let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fO85U")).then(() => parcelRequire('aPYHA'));